import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorStateProps {
  message: string;
  className?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message, className = "" }) => {
  const sanitizeString = (input: string, maxLength: number = 500): string => {
    if (typeof input !== 'string') return '';
    return input.replace(/[<>"'&]/g, '').substring(0, maxLength).trim();
  };
  const safeClass = typeof className === 'string' ? className : '';
  const safeMessage = sanitizeString(message, 500);
  return (
  <div className={`px-4 py-6 sm:px-6 lg:px-10 ${safeClass}`}>
    <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
      <AlertCircle className="w-12 h-12 text-red-400 mx-auto mb-3" />
      <h3 className="text-lg font-medium text-red-800 mb-2">Oops! Something went wrong</h3>
      <p className="text-red-600">{safeMessage}</p>
    </div>
  </div>
  );
}

export default ErrorState;
